// Issues + Locations mutations (PG server). resolveIssueWithCorrectiveTask lives in
// graphql/tasks/mutations.ts (it accompanies createTask) — import from there.

import {ISSUE_FIELDS_GQL, LOCATION_FIELDS_GQL} from "./queries";

export const createIssue = /* GraphQL */ `
  mutation createIssue($input: CreateIssueInput!) {
    createIssue(input: $input) { ${ISSUE_FIELDS_GQL} }
  }
`;

export const updateIssue = /* GraphQL */ `
  mutation updateIssue($input: UpdateIssueInput!) {
    updateIssue(input: $input) { ${ISSUE_FIELDS_GQL} }
  }
`;

export const resolveIssueWithNote = /* GraphQL */ `
  mutation resolveIssueWithNote($input: ResolveIssueWithNoteInput!) {
    resolveIssueWithNote(input: $input) { ${ISSUE_FIELDS_GQL} }
  }
`;

export const dismissIssue = /* GraphQL */ `
  mutation dismissIssue($input: DismissIssueInput!) {
    dismissIssue(input: $input) { ${ISSUE_FIELDS_GQL} }
  }
`;

export const reopenIssue = /* GraphQL */ `
  mutation reopenIssue($id: ID!) {
    reopenIssue(id: $id) { ${ISSUE_FIELDS_GQL} }
  }
`;

export const archiveIssue = /* GraphQL */ `
  mutation archiveIssue($id: ID!) {
    archiveIssue(id: $id) { ${ISSUE_FIELDS_GQL} }
  }
`;

export const unarchiveIssue = /* GraphQL */ `
  mutation unarchiveIssue($id: ID!) {
    unarchiveIssue(id: $id) { ${ISSUE_FIELDS_GQL} }
  }
`;

export const deleteIssue = /* GraphQL */ `
  mutation deleteIssue($id: ID!) {
    deleteIssue(id: $id) { ${ISSUE_FIELDS_GQL} }
  }
`;

export const createLocation = /* GraphQL */ `
  mutation createLocation($input: CreateLocationInput!) {
    createLocation(input: $input) { ${LOCATION_FIELDS_GQL} }
  }
`;

export const updateLocation = /* GraphQL */ `
  mutation updateLocation($input: UpdateLocationInput!) {
    updateLocation(input: $input) { ${LOCATION_FIELDS_GQL} }
  }
`;

export const deleteLocation = /* GraphQL */ `
  mutation deleteLocation($id: ID!) {
    deleteLocation(id: $id) { ${LOCATION_FIELDS_GQL} }
  }
`;
